<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <table cellspacing="0" cellpadding="0" border="0">
      <tr>
        <ng-container *mailgunIf="data.avatar_url">
          <td align="left" width="48" height="48">
            <img class="avatar" width="48" height="48" [src]="data.avatar_url.toJSON()" />
          </td>
          <td width="12">&nbsp;</td>
        </ng-container>

        <td align="left" class="web-notification-title">
          <email-text [contents]="data.title_html" />
        </td>
      </tr>
    </table>
  </ng-container>

  <ng-container body>
    <email-margin [height]="28" />
    <email-infobox [contents]="data.note_body_html" />
    <email-margin [height]="16" />
    <email-button [href]="data.button_link" [label]="data.button_text" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer_p1" color="light" presetName="paragraph" size="small" />
    <email-link
      [label]="data.footer_link_text"
      [href]="data.footer_link"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
